import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ISubjectNoteList, SubjectNote } from '../models/subject-note';
import { BaseRestService } from './base-rest.service';
import { forkJoin, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { UserService } from './user.service';
import { User } from '../models/user';
import { NoteType } from '../models/note';
import { NoteTypeService } from './note-type.service';

@Injectable({ providedIn: 'root' })
export class SubjectNoteService extends BaseRestService<SubjectNote, ISubjectNoteList>{

  constructor(http: HttpClient, private userService: UserService, protected router: Router, private noteTypeService: NoteTypeService) {
    super(SubjectNoteService, http, 'api/subjectnotes', 'subject note', router);

    // enable caching
    this.cacheEnabled = false;
  }

  getNotes(subjectUid: string, type?: string): Observable<SubjectNote[]> {
    const url = subjectUid + '/' + ((type) ? type : 'all');
    return this.getAllData(url);
  }

  save(note, successMessage?: string) {
    if ((note.subject) && (note.subject.createdById)){
      note.subject.createdBy = null;
    }
    super.save(note as SubjectNote, successMessage);
  }

  hydrate(item: SubjectNote): Observable<SubjectNote> {
    const hydrate$ = [];

    // created by user
    if ((item.note) && (item.note.createdById) && ((!item.note.user) || (item.note.user.id !== item.note.createdById))) {
      hydrate$.push(this.userService.getById(item.note.createdById).pipe(take(1), map((user) => {
        item.note.user = new User(user);
        return item;
      })));
    }

    if (item.note && item.note.noteTypeId && ((!item.note.noteType) || (item.note.noteType.id !== item.note.noteTypeId))){
      hydrate$.push(this.noteTypeService.getById(item.note.noteTypeId).pipe(take(1), map((noteType) => {
        item.note.noteType = noteType || undefined;
        return item;
      })));
    }

    if (hydrate$.length > 0) {
      return forkJoin(hydrate$).pipe(take(1), map((_) => {
        return item;
      }));
    }
    else {
      return of(item);
    }
  }
}
